// Vorschau des Posteingangs „Neu für dich“ im Tab „Für dich“ (Marcel 25.10.2026, wie die App):
// höchstens 6 Einträge, darunter „Alles anzeigen“ (Vollbild), damit der Feed gefolgter Seiten
// nicht unter den Benachrichtigungen verschwindet. PURE.
export const INBOX_PREVIEW_MAX = 6;

export interface InboxPreview { visibleCount: number; showAll: boolean }

export function inboxPreview(total: number, { maxItems = INBOX_PREVIEW_MAX, embedded = false }: { maxItems?: number; embedded?: boolean } = {}): InboxPreview {
  const n = Number.isFinite(total) && total > 0 ? Math.floor(total) : 0;
  if (embedded) return { visibleCount: n, showAll: false };
  return { visibleCount: Math.min(n, maxItems), showAll: n > maxItems };
}

/** Vorschau holt einen Eintrag mehr als sichtbar (Button nur, wenn es wirklich mehr gibt); Profil/Vollbild 30 */
export function inboxFetchLimit({ maxItems = INBOX_PREVIEW_MAX, embedded = false, embeddedLimit = 30 }: { maxItems?: number; embedded?: boolean; embeddedLimit?: number } = {}): number {
  return embedded ? embeddedLimit : maxItems + 1;
}
